<!--
 * @Description: 新增机构-开通服务面板组件
 * @Author: wanqian
 * @Date: 2022-03-28 16:58:14
-->
<template>
  <div class="body">
    <div class="openhservice-panel-main">
    	<el-form class="openingHsvcForm" ref="openingHsvcForm" :model="openingHsvcForm" :rules="rules" 
        label-position="top" label-width="200px">
				<div v-for="(openingHsvc, index) in openingHsvcForm.openingHsvcList" :key="index">
					<el-row style="margin: 10px 0 0 0; height: 40px" :gutter="20" type="flex" align="middle">
						<el-form-item label="">
							<el-checkbox v-model="openingHsvc.opened" disabled>{{openingHsvc.hsvcCategoryText}}</el-checkbox>
						</el-form-item>
						<el-form-item style="margin-left: 20px" label="" :prop="'openingHsvcList.' + index + '.timeRange'" 
              :rules="{ required: true, message: '请选择服务时间', trigger: 'blur' }">
							<el-time-picker style="width:260px" size="small" v-model="openingHsvc.timeRange" is-range 
                placeholder="选择时间范围" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" 
                :readonly="readonly" :clearable="false"	format = 'HH:mm:ss' value-format = 'HH:mm:ss' 
                @change="handleTimePickerChange(openingHsvc, index)">
							</el-time-picker>
						</el-form-item>
						<el-form-item label="">
							<el-checkbox style="margin-left: 25px" v-model="openingHsvc.isWholeDay" :disabled="readonly" 
								:true-label="1" :false-label="0" @change="handleIsWholeDayChange(openingHsvc, index)">
                全天(24小时服务)
              </el-checkbox>
						</el-form-item>
					</el-row>
          <el-row style="margin: 30px 5px" :gutter="0" type="flex" justify="space-between" align="middle">
            <el-form-item label="护理员等级价格：" prop="levelPrices">
              <div class="bk-level-prices">
                <div class="level-price-item">
                  <span>初级护理员：</span>
                  <el-input style="width: 130px" size="small" v-model.trim="openingHsvc.primaryPriceYuan" 
                    placeholder="请输入" disabled @input="inputLevelPrice('primary', index, openingHsvc)">
                    <template slot="append">元</template>
                  </el-input>
                </div>
                <div class="level-price-item">
                  <span>中级护理员：</span>
                  <el-input style="width: 130px" size="small" v-model.trim="openingHsvc.middlePriceYuan" 
                    placeholder="请输入" :readonly="readonly" @input="inputLevelPrice('middle', index, openingHsvc)">
                    <template slot="append">元</template>
                  </el-input>
                </div>
                <div class="level-price-item">
                  <span>高级护理员：</span>
                  <el-input style="width: 130px" size="small" v-model.trim="openingHsvc.highPriceYuan" 
                    placeholder="请输入" :readonly="readonly" @input="inputLevelPrice('high', index, openingHsvc)">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </div>
            </el-form-item>
				  </el-row>
				</div>
			</el-form>
		</div>
    <div class="bk-wizard-bottons" style="padding-right: 25px">
      <wizard-buttons :mode="mode" :status="btnStatus" @btnpressed="handleBtnSelection" />
    </div>
  </div>
</template>

<script>
import instStore from './InstStore.js'

let InstOpenHservicePanel = {
  name: 'InstOpenHservicePanel',
  instStore,

  data() {
    let validLevelPrices = (_rule, _value, callback) => {
      let validPrimaryPriceYuan = true;
      let validMiddlePriceYuan = true;
      let validHighPriceYuan = true;
      this.openingHsvcForm.openingHsvcList.forEach((item, _index) => {
        if (!item.primaryPriceYuan || item.primaryPriceYuan.length == 0) {
          validPrimaryPriceYuan = false;
        } else if (!item.middlePriceYuan || item.middlePriceYuan.length == 0) {
          validMiddlePriceYuan = false;
        } else if (!item.highPriceYuan || item.highPriceYuan.length == 0) {
          validHighPriceYuan = false;
        }
      })
      if (!validPrimaryPriceYuan) callback(new Error('请输入初级护理员价格'));
      if (!validMiddlePriceYuan) callback(new Error('请输入中级护理员价格'));
      if (!validHighPriceYuan) callback(new Error('请输入高级护理员价格'));
      callback();
    };

    return {
      btnStatus: {'prev': true, 'next': false, 'submit': true},
      rules: {
        levelPrices: [{required: true, validator: validLevelPrices, trigger: 'blur'}],
      },
      openingHsvcForm: {openingHsvcList: []},
    }
  },

  computed: {
    mode() {
      return instStore.state.mode;
    },

    readonly() {
      return instStore.state.mode == 'details';
    }
  },

  methods: {
    initData() {
      //后台返回时间数据只有时分秒，人为拼接上临时日期，用于timePicker显示交互，在提交是会去掉拼接的日期
      let arr = instStore.state.openingHsvcList;
      let openingHsvcList = [];
      if (!arr) {
        this.$set(this.openingHsvcForm, 'openingHsvcList', []);
        return;
      }
      arr.forEach((element, _index) => {
        if (element.startTime && element.endTime) {
          let startTime = "2016-09-10 " + element.startTime;
          let endTime = "2016-09-10 " + element.endTime;
          let startTimeDate = this.dateUtil.dateTimeFormat(startTime);
          let endTimeDate = this.dateUtil.dateTimeFormat(endTime);
          this.$set(element, 'timeRange', [startTimeDate, endTimeDate]);
        }
        openingHsvcList.push(element);
      });
      this.$set(this.openingHsvcForm, 'openingHsvcList', openingHsvcList);
    },

		//全天切换
    handleIsWholeDayChange(item, index) {
      if (item.isWholeDay == 1) {
        item.startTime = "00:00:00";
        item.endTime = "23:59:59";
        let startTimeDate = this.dateUtil.dateTimeFormat('2016-09-10 ' + item.startTime);
        let endTimeDate = this.dateUtil.dateTimeFormat('2016-09-10 ' + item.endTime);
        item.timeRange = [startTimeDate,endTimeDate];
        this.openingHsvcForm.openingHsvcList.splice(index, 1);
        this.openingHsvcForm.openingHsvcList.splice(index, 0, item);
      }
    },

    //选择时间改变
    handleTimePickerChange(item, index) {
      if (item.timeRange[0] == "00:00:00" && item.timeRange[1] == "23:59:59") {
        item.isWholeDay = 1;
      } else {
        item.isWholeDay = 0;
      }
      this.openingHsvcForm.openingHsvcList.splice(index, 1);
      this.openingHsvcForm.openingHsvcList.splice(index, 0, item);
    },

		inputLevelPrice(type, index, openingHsvc) {
      openingHsvc = this.handleLevelPrice(type, openingHsvc);
      this.openingHsvcForm.openingHsvcList.splice(index, 1, openingHsvc);
		},

    handleLevelPrice(type, openingHsvc) {
      let key = type + 'PriceYuan';
      openingHsvc[key] = this.commonUtil.filterDigitals(openingHsvc[key], ['.']);
      if (openingHsvc[key].length > 5) {
        openingHsvc[key] = openingHsvc[key].slice(0, 5);
      }
      return openingHsvc;
    },

    handleBtnSelection(operate) {
      if (this.mode == 'details' || operate != 'next' && operate != 'add' && operate != 'edit')  {
        this.$emit("panel-operate", operate);
        return true;
      }
      this.$refs.openingHsvcForm.validate((valid) => {
        if (!valid) return false;
        else {
          this.$emit("panel-operate", operate);
          return true;
        }
      });
    },

    rebuildDataAndSync() {
      //将timeRange的值去掉前面加的日期（2016-09-10 ）再赋值给startTime和endTime，否则下次切换回来时段显示有问题
      this.openingHsvcForm.openingHsvcList.forEach(element => {
        if (element.timeRange && element.timeRange.length == 2) {
          element.startTime = element.timeRange[0].indexOf('2016-09-10 ') == -1 ? element.timeRange[0] 
            : element.timeRange[0].substr(11);
          element.endTime = element.timeRange[1].indexOf('2016-09-10 ') == -1 ? element.timeRange[1] 
            : element.timeRange[1].substr(11);
        }
      });
      //销毁的时候同步数据
      instStore.commit('changeOpeningHsvcList', this.openingHsvcForm.openingHsvcList);
    },
  },

  mounted() {
    this.initData();
  },

  destroyed() {
    this.rebuildDataAndSync();
  },
}
export default InstOpenHservicePanel
</script>

<style scoped>
.openhservice-panel-main {
  margin: 20px 92px 0 25px;
	padding-top: 30px;
	text-align: left;
}
.openingHsvcForm {
  margin-bottom: 60px;
}
.bk-level-prices {
	margin-top: 22px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
}
.level-price-item {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 30px 10px 0;
}
</style>
<style>
.openhservice-panel-main .el-form--label-top .el-form-item__label {
	padding: 0px;
  line-height: 26px;
}
.openhservice-panel-main .el-form-item__content {
  line-height: initial;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/components/institutiondetails/InstOpenHservicePanel.vue